import apiClient from './api';
import { Supplier, SupplierDTO, SupplierAdmin } from '../models/Supplier';

const PKEY = process.env.REACT_APP_PUBLISHABLE_KEY || '';

const ALREADY_EXISTS_PATTERN = /already exists/i;
const ALREADY_AUTHENTICATED_PATTERN = /already authenticated as a service provider/i;

const getBackendMessage = (error: any): string =>
  error?.response?.data?.message || error?.response?.data?.error || '';

const throwProfileCreationFailed = (): never => {
  const profileError: any = new Error('PROFILE_CREATION_FAILED');
  profileError.profileCreationFailed = true;
  throw profileError;
};

async function createSupplierProfile(registerData: Supplier, token: string) {
  const supplierDTO = new SupplierDTO();
  supplierDTO.name = registerData.supplier_name;
  supplierDTO.handle = 'sp' + registerData.supplier_name.replace(/\s+/g, '');
  supplierDTO.admin = new SupplierAdmin();
  supplierDTO.admin.email = registerData.email;
  supplierDTO.admin.first_name = registerData.first_name;
  supplierDTO.admin.last_name = registerData.last_name;

  await apiClient.post('/service-providers', supplierDTO, {
    headers: {
      Authorization: `Bearer ${token}`,
      'x-publishable-api-key': PKEY,
    },
  });
}

async function recoverExistingAccount(registerData: Supplier) {
  await supplierLogin(registerData.email, registerData.password);

  try {
    await createSupplierProfile(registerData, getAuthToken() as string);
  } catch (error: any) {
    if (ALREADY_AUTHENTICATED_PATTERN.test(getBackendMessage(error))) {
      return;
    }
    throwProfileCreationFailed();
  }

  await supplierLogin(registerData.email, registerData.password);
}

export async function registerSupplier(registerData: Supplier) {
  let token: string;
  try {
    const authResponse = await apiClient.post('/auth/service-provider/emailpass/register', {
      email: registerData.email,
      password: registerData.password,
    });
    token = authResponse.data.token;
  } catch (error: any) {
    if (ALREADY_EXISTS_PATTERN.test(getBackendMessage(error))) {
      await recoverExistingAccount(registerData);
      return;
    }
    throw error;
  }

  try {
    await createSupplierProfile(registerData, token);
  } catch (error) {
    throwProfileCreationFailed();
  }

  await supplierLogin(registerData.email, registerData.password);
}

export async function supplierLogin(email: string, password: string) {
  const response = await apiClient.post('/auth/service-provider/emailpass', {
    email,
    password,
  });

  localStorage.setItem('supplier_auth_token', response.data.token);
}

export async function logout() {
  localStorage.removeItem('supplier_auth_token');
}

export function isAuthenticated(): boolean {
  return !!localStorage.getItem('supplier_auth_token');
}

export function getAuthToken(): string | null {
  return localStorage.getItem('supplier_auth_token');
}
